import { Controller } from "@hotwired/stimulus";
import { useIntersection } from "stimulus-use";

/**
 * モーダル抑止 Cookie 設定用の汎用コントローラー
 * data-controller="modal-suppression"
 *   data-modal-suppression-url-value="<%= modal_mark_shown_path(:car_wish) %>"
 *
 * IntersectionObserver でモーダルがビューポートに表示されたタイミングで
 * url-value 宛に POST し、再表示抑止 Cookie をサーバー側で設定する。
 * 抑止対象 key は URL path に埋め込まれるため、 JS 側は key を知らない。
 */
export default class extends Controller {
  static values = {
    url: String,
  };

  #unobserve = null;

  connect() {
    if (!this.hasUrlValue) {
      console.error("Missing url value", this.element);
      return;
    }

    const [, unobserve] = useIntersection(this);
    this.#unobserve = unobserve;
  }

  disconnect() {
    this.#stopObserve();
  }

  appear() {
    this.#stopObserve();
    this.#markShown();
  }

  #stopObserve() {
    if (!this.#unobserve) {
      return;
    }

    this.#unobserve();
    this.#unobserve = null;
  }

  #markShown() {
    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]',
    )?.content;
    if (!csrfToken) {
      console.warn("CSRF token not found, skipping modal-suppression request");
      return;
    }

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
    }).catch(() => {
      // 失敗時は Cookie が未設定のためモーダルが再表示される（安全側）
    });
  }
}
